import moment from 'moment'
import * as countryStates from '../config/country_state_province.json'
import prefferedLanguage from '../config/preffered_language.json'

const filter = {
/**
* convert advance search form in to ES Query
* @param {*} attributeName
* @param {*} value
* @param {*} operationLabel
* @returns converted query
*/
convertInToQuery: (attributeName, value, operationLabel) => {
let query = '';
let operation = filter.getkey(operationLabel);
if (operationLabel === 'Exists') {
query = operation + "(" + attributeName + ")";
} else if (operationLabel === 'Not Exists') {
query = operation + "(" + attributeName + "))";
} else {
if (value instanceof Array) {
let concatAraay = '';
value.forEach((item, i) => {
if (i !== 0) {
concatAraay += ',"' + item + '"'
} else {
concatAraay += '"' + item + '"'
}

})
if (operationLabel === 'In Range' && !isNaN(value[0])) {
if (parseFloat(value[0]) > parseFloat(value[1])) {
query = operation + "(" + attributeName + "," + value[1] + ',' + value[0] + ")";
} else {
query = operation + "(" + attributeName + "," + value[0] + ',' + value[1] + ")";
}
} else if (operationLabel === 'In Range' && isNaN(value[0])) {
if (moment.utc(new Date(value[0])).isAfter(new Date(value[1]))) {
query = operation + "(" + attributeName + ",'" + value[1] + "','" + value[0] + "')";
} else {
query = operation + "(" + attributeName + ",'" + value[0] + "','" + value[1] + "')";
}
}
else {
if (operationLabel.startsWith('Not')) {
query = operation + "(" + attributeName + ",[" + concatAraay + "]))";
} else {
query = operation + "(" + attributeName + ",[" + concatAraay + "])";
}
}

} else {
if (operationLabel.startsWith('Not')) {
query = operation + "(" + attributeName + ",'" + value + "'))";
} else {
if (operationLabel === 'Equals' || operationLabel === 'Contains') {
query = operation + "(" + attributeName + ",[\"" + value + "\"])";
} else {
query = operation + "(" + attributeName + ",'" + value + "')";
}

}

}
}
return query;
},
/**
* dynamic filter mapping
* @param {*} data
* @returns maaped dynamic label and options
*/
finalMethod: (data) => {

let temp = data.map(e => e._source);
temp.forEach(element => {
let keys = Object.keys(element);
keys.forEach(key => {
if (typeof element[key] === 'string') {
delete element[key];
}
})
});
filter.loadFilter(temp);
let map1 = new Map();
filter.loadTestMap(temp, map1);
let newMap = new Map();
map1.forEach((val, key) => {
newMap.set(key, val.filter((x, i, a) => a.indexOf(x) === i))
});
return newMap;
},
/**
* logic for maping label and option
* @param {*} arr
* @param {*} map
* @param {*} parent
*/
loadTestMap: (arr, map, parent) => {
if (arr instanceof Array) {
arr.forEach(el => {
let keys = Object.keys(el);
keys.forEach(key => {
if (el[key] instanceof Array && el[key].length > 0 && (typeof el[key][0] === 'string')) {
let temp = map.get((parent === undefined ? (key) : (parent + '.' + key)));
if (temp) {
map.set((parent === undefined ? (key) : (parent + '.' + key)), [...el[key], ...temp]);
} else {
map.set((parent === undefined ? (key) : (parent + '.' + key)), el[key]);
}
} else {
filter.loadTestMap(el[key], map, (parent === undefined ? key : parent + '.' + key));
}
})
});
} else {
if (arr) {
Object.keys(arr).forEach(key => {
if (arr[key] instanceof Array && arr[key].length > 0 && (typeof arr[key][0] === 'string')) {
let temp = map.get((parent === undefined ? (key) : (parent + '.' + key)));
if (temp) {
map.set((parent === undefined ? (key) : (parent + '.' + key)), [...arr[key], ...temp]);
} else {
map.set((parent === undefined ? (key) : (parent + '.' + key)), arr[key]);
}
} else {
filter.loadTestMap(arr[key], map, (parent === undefined ? key : parent + '.' + key));
}
})
}
}
},
/**
* unique options Maping
* @param {*} val
* @returns mapped Dynamic filter
*/
loadFilter: (val) => {
try {
if (val instanceof Array) {
val.forEach(element => {
let keys = Object.keys(element);
keys.forEach(key => {
let tempAr = [];
element[key]?.forEach(el => {
if (typeof el.value === 'string') {
tempAr.push(el.value);
} else if (el instanceof Object) {
tempAr.push(filter.loadFilter(el));
} else {
filter.loadFilter(el.value);
}
});
element[key] = tempAr;

})
});
} else if (val instanceof Object) {
let keys = Object.keys(val);
keys.forEach(key => {
let tempAr = [];
val[key]?.forEach(el => {
if (typeof el.value === 'string') {
tempAr.push(el.value);
} else if (val instanceof Object) {
tempAr = filter.loadFilter(el);
} else {
filter.loadFilter(el.value);
}
})
val[key] = tempAr;
})
return val;
}
} catch (error) {

}
},
/**
* Entery point
*/
formFilterData: (data) => {
try {
let map1 = filter.finalMethod(data);
return map1;
} catch (error) {

return [];
}

},
/**
* key value for operation
* @param {*} opration
* @returns key
*/
getkey: (opration) => {
switch (opration) {
case 'Equals':
return 'equals';
case 'Not Equals':
return 'not(equals';
case 'Exists':
return 'exists';
case 'Not Exists':
return 'not(exists';
case 'Contains':
return 'contains';
case 'In Range':
return 'range';
case 'Less Than':
return 'lt';
case 'Greater Than':
return 'gt';
default:
return opration

}
},
/**
*name to symbol
* @param {*} opration
* @returns symbol
*/
getSymbols: (opration) => {
switch (opration) {
case 'Equals':
return '=';
case 'Not Equals':
return '≠';
case 'Exists':
return 'exists';
case 'Not Exists':
return 'missing';
case 'Contains':
return '~';
case 'In Range':
return 'within';
case 'Less Than':
return 'lt';
case 'Greater Than':
return 'gt';
default:
return opration
}
},
/**
* label mapping
* @param {*} key
* @returns mapped value
*/
getLabelName: (key) => {
switch (key) {
case 'Address I D':
return 'Address ID';
case 'Source Address Id':
return 'Source Address ID';
default:
return key;
}
},

/**
* LOV bounded picklist mapping
* @param {*} value
* @returns mapped list
*/
mapPickList: (value) => {
let stateProvince = ["No States for US"]
stateProvince = (countryStates?.default['United States'] ?? []).map(item => item.code)
let picklist = {
HCP:{
Specialty: value.HCP?.["spclty"]
? sortData([
...value.HCP["spclty"],
...(Array.isArray(value.UNCLASSIFIED?.spclty) ? value.UNCLASSIFIED["spclty"].map(item => `${item}//UnClassified`) : [])
])
: sortData([
...(Array.isArray(value.UNCLASSIFIED?.spclty) ? value.UNCLASSIFIED["spclty"].map(item => `${item}//UnClassified`) : [])
]),

Classification: value.HCP?.["clsfctn"]
? sortData([
...value.HCP["clsfctn"],
...(Array.isArray(value.UNCLASSIFIED?.clsfctn) ? value.UNCLASSIFIED["clsfctn"].map(item => `${item}//UnClassified`) : [])
])
: sortData([
...(Array.isArray(value.UNCLASSIFIED?.clsfctn) ? value.UNCLASSIFIED["clsfctn"].map(item => `${item}//UnClassified`) : [])
]),

SubClassification: value.HCP?.["sub_clsfctn"]
? sortData([
...value.HCP["sub_clsfctn"],
...(Array.isArray(value.UNCLASSIFIED?.sub_clsfctn) ? value.UNCLASSIFIED["sub_clsfctn"].map(item => `${item}//UnClassified`) : [])
])
: sortData([
...(Array.isArray(value.UNCLASSIFIED?.sub_clsfctn) ? value.UNCLASSIFIED["sub_clsfctn"].map(item => `${item}//UnClassified`) : [])
]),

Title: value.HCP?.["title"]
? sortData([
...value.HCP["title"],
...(Array.isArray(value.UNCLASSIFIED?.title) ? value.UNCLASSIFIED["title"].map(item => `${item}//UnClassified`) : [])
])
: sortData([
...(Array.isArray(value.UNCLASSIFIED?.title) ? value.UNCLASSIFIED["title"].map(item => `${item}//UnClassified`) : [])
]),

AltIDType: value.HCP?.["altrnt_id_typ"]
? [
...value.HCP["altrnt_id_typ"],
...(Array.isArray(value.UNCLASSIFIED?.altrnt_id_typ) ? value.UNCLASSIFIED["altrnt_id_typ"].map(item => `${item}//UnClassified`) : [])
]
: [
...(Array.isArray(value.UNCLASSIFIED?.altrnt_id_typ) ? value.UNCLASSIFIED["altrnt_id_typ"].map(item => `${item}//UnClassified`) : [])
],

AltIDSubtype: value.HCP?.["altrnt_id_subtyp"]
? [
...value.HCP["altrnt_id_subtyp"],
...(Array.isArray(value.UNCLASSIFIED?.altrnt_id_subtyp) ? value.UNCLASSIFIED["altrnt_id_subtyp"].map(item => `${item}//UnClassified`) : [])
]
: [
...(Array.isArray(value.UNCLASSIFIED?.altrnt_id_subtyp) ? value.UNCLASSIFIED["altrnt_id_subtyp"].map(item => `${item}//UnClassified`) : [])
],
StateProvince: stateProvince,
Gender: value.HCP?.['gender'] ? value.HCP?.['gender'] : value.HCP?.['Gender'] ? value.HCP?.['Gender'] : [],
PreferredLanguage: prefferedLanguage
},
HCO: {
Specialty: value.HCO?.["spclty"]
? sortData([
...value.HCO["spclty"],
...(Array.isArray(value?.UNCLASSIFIED?.spclty) ? value.UNCLASSIFIED["spclty"].map(item => `${item}//UnClassified`) : [])
])
: sortData([
...(Array.isArray(value?.UNCLASSIFIED?.spclty) ? value.UNCLASSIFIED["spclty"].map(item => `${item}//UnClassified`) : [])
]),

Classification: value.HCO?.["clsfctn"]
? sortData([
...value.HCO["clsfctn"],
...(Array.isArray(value?.UNCLASSIFIED?.clsfctn) ? value.UNCLASSIFIED["clsfctn"].map(item => `${item}//UnClassified`) : [])
])
: sortData([
...(Array.isArray(value?.UNCLASSIFIED?.clsfctn) ? value.UNCLASSIFIED["clsfctn"].map(item => `${item}//UnClassified`) : [])
]),

SubClassification: value.HCO?.["sub_clsfctn"]
? sortData([
...value.HCO["sub_clsfctn"],
...(Array.isArray(value?.UNCLASSIFIED?.sub_clsfctn) ? value.UNCLASSIFIED["sub_clsfctn"].map(item => `${item}//UnClassified`) : [])
])
: sortData([
...(Array.isArray(value?.UNCLASSIFIED?.sub_clsfctn) ? value.UNCLASSIFIED["sub_clsfctn"].map(item => `${item}//UnClassified`) : [])
]),

Title: value.HCO?.["title"]
? sortData([
...value.HCO["title"],
...(Array.isArray(value?.UNCLASSIFIED?.title) ? value.UNCLASSIFIED["title"].map(item => `${item}//UnClassified`) : [])
])
: sortData([
...(Array.isArray(value?.UNCLASSIFIED?.title) ? value.UNCLASSIFIED["title"].map(item => `${item}//UnClassified`) : [])
]),

AltIDType: value.HCO?.["altrnt_id_typ"]
? [
...value.HCO["altrnt_id_typ"],
...(Array.isArray(value?.UNCLASSIFIED?.altrnt_id_typ) ? value.UNCLASSIFIED["altrnt_id_typ"].map(item => `${item}//UnClassified`) : [])
]
: [
...(Array.isArray(value?.UNCLASSIFIED?.altrnt_id_typ) ? value.UNCLASSIFIED["altrnt_id_typ"].map(item => `${item}//UnClassified`) : [])
],

AltIDSubtype: value.HCO?.["altrnt_id_subtyp"]
? [
...value.HCO["altrnt_id_subtyp"],
...(Array.isArray(value?.UNCLASSIFIED?.altrnt_id_subtyp) ? value.UNCLASSIFIED["altrnt_id_subtyp"].map(item => `${item}//UnClassified`) : [])
]
: [
...(Array.isArray(value?.UNCLASSIFIED?.altrnt_id_subtyp) ? value.UNCLASSIFIED["altrnt_id_subtyp"].map(item => `${item}//UnClassified`) : [])
],
StateProvince: value.HCO?.["administrative_areas"] ? value.HCO?.["administrative_areas"].filter((res, index, array)=> array.indexOf(res) === index) : stateProvince,
RelationType: value.HCO?.["relationship_type"] ? value.HCO?.["relationship_type"] : [],
}

}
return picklist;
},


/**
* LOV bounded picklist mapping
* @param {*} value
* @returns mapped list
*/
mapVnPickList: (value) => {
let stateProvince = ["No States for US"]
stateProvince = (countryStates?.default['United States'] ?? []).map(item => item.code)
let picklist = {
HCP:{
Specialty: value.HCP?.["spclty_vn"]
? sortData([
...value.HCP["spclty_vn"],
...(Array.isArray(value.UNCLASSIFIED?.spclty_vn) ? value.UNCLASSIFIED["spclty_vn"].map(item => `${item}//UnClassified`) : [])
])
: sortData([
...(Array.isArray(value.UNCLASSIFIED?.spclty_vn) ? value.UNCLASSIFIED["spclty_vn"].map(item => `${item}//UnClassified`) : [])
]),

Classification: value.HCP?.["clsfctn_vn"]
? sortData([
...value.HCP["clsfctn_vn"],
...(Array.isArray(value.UNCLASSIFIED?.clsfctn_vn) ? value.UNCLASSIFIED["clsfctn_vn"].map(item => `${item}//UnClassified`) : [])
])
: sortData([
...(Array.isArray(value.UNCLASSIFIED?.clsfctn_vn) ? value.UNCLASSIFIED["clsfctn_vn"].map(item => `${item}//UnClassified`) : [])
]),

SubClassification: value.HCP?.["sub_clsfctn_vn"]
? sortData([
...value.HCP["sub_clsfctn_vn"],
...(Array.isArray(value.UNCLASSIFIED?.sub_clsfctn_vn) ? value.UNCLASSIFIED["sub_clsfctn_vn"].map(item => `${item}//UnClassified`) : [])
])
: sortData([
...(Array.isArray(value.UNCLASSIFIED?.sub_clsfctn_vn) ? value.UNCLASSIFIED["sub_clsfctn_vn"].map(item => `${item}//UnClassified`) : [])
]),

Title: value.HCP?.["title_vn"]
? sortData([
...value.HCP["title_vn"],
...(Array.isArray(value.UNCLASSIFIED?.title_vn) ? value.UNCLASSIFIED["title_vn"].map(item => `${item}//UnClassified`) : [])
])
: sortData([
...(Array.isArray(value.UNCLASSIFIED?.title_vn) ? value.UNCLASSIFIED["title_vn"].map(item => `${item}//UnClassified`) : [])
]),

AltIDType: value.HCP?.["altrnt_id_typ_vn"]
? [
...value.HCP["altrnt_id_typ_vn"],
...(Array.isArray(value.UNCLASSIFIED?.altrnt_id_typ_vn) ? value.UNCLASSIFIED["altrnt_id_typ_vn"].map(item => `${item}//UnClassified`) : [])
]
: [
...(Array.isArray(value.UNCLASSIFIED?.altrnt_id_typ_vn) ? value.UNCLASSIFIED["altrnt_id_typ_vn"].map(item => `${item}//UnClassified`) : [])
],

AltIDSubtype: value.HCP?.["altrnt_id_subtyp_vn"]
? [
...value.HCP["altrnt_id_subtyp_vn"],
...(Array.isArray(value.UNCLASSIFIED?.altrnt_id_subtyp_vn) ? value.UNCLASSIFIED["altrnt_id_subtyp_vn"].map(item => `${item}//UnClassified`) : [])
]
: [
...(Array.isArray(value.UNCLASSIFIED?.altrnt_id_subtyp_vn) ? value.UNCLASSIFIED["altrnt_id_subtyp_vn"].map(item => `${item}//UnClassified`) : [])
],
StateProvince: stateProvince,
Gender: value.HCP?.['gender'] ? value.HCP?.['gender'] : value.HCP?.['Gender'] ? value.HCP?.['Gender'] : []
},
HCO: {
Specialty: value.HCO?.["spclty"]
? sortData([
...value.HCO["spclty"],
...(Array.isArray(value?.UNCLASSIFIED?.spclty) ? value.UNCLASSIFIED["spclty"].map(item => `${item}//UnClassified`) : [])
])
: sortData([
...(Array.isArray(value?.UNCLASSIFIED?.spclty) ? value.UNCLASSIFIED["spclty"].map(item => `${item}//UnClassified`) : [])
]),

Classification: value.HCO?.["clsfctn"]
? sortData([
...value.HCO["clsfctn"],
...(Array.isArray(value?.UNCLASSIFIED?.clsfctn) ? value.UNCLASSIFIED["clsfctn"].map(item => `${item}//UnClassified`) : [])
])
: sortData([
...(Array.isArray(value?.UNCLASSIFIED?.clsfctn) ? value.UNCLASSIFIED["clsfctn"].map(item => `${item}//UnClassified`) : [])
]),

SubClassification: value.HCO?.["sub_clsfctn"]
? sortData([
...value.HCO["sub_clsfctn"],
...(Array.isArray(value?.UNCLASSIFIED?.sub_clsfctn) ? value.UNCLASSIFIED["sub_clsfctn"].map(item => `${item}//UnClassified`) : [])
])
: sortData([
...(Array.isArray(value?.UNCLASSIFIED?.sub_clsfctn) ? value.UNCLASSIFIED["sub_clsfctn"].map(item => `${item}//UnClassified`) : [])
]),

Title: value.HCO?.["title"]
? sortData([
...value.HCO["title"],
...(Array.isArray(value?.UNCLASSIFIED?.title) ? value.UNCLASSIFIED["title"].map(item => `${item}//UnClassified`) : [])
])
: sortData([
...(Array.isArray(value?.UNCLASSIFIED?.title) ? value.UNCLASSIFIED["title"].map(item => `${item}//UnClassified`) : [])
]),

AltIDType: value.HCO?.["altrnt_id_typ"]
? [
...value.HCO["altrnt_id_typ"],
...(Array.isArray(value?.UNCLASSIFIED?.altrnt_id_typ) ? value.UNCLASSIFIED["altrnt_id_typ"].map(item => `${item}//UnClassified`) : [])
]
: [
...(Array.isArray(value?.UNCLASSIFIED?.altrnt_id_typ) ? value.UNCLASSIFIED["altrnt_id_typ"].map(item => `${item}//UnClassified`) : [])
],

AltIDSubtype: value.HCO?.["altrnt_id_subtyp"]
? [
...value.HCO["altrnt_id_subtyp"],
...(Array.isArray(value?.UNCLASSIFIED?.altrnt_id_subtyp) ? value.UNCLASSIFIED["altrnt_id_subtyp"].map(item => `${item}//UnClassified`) : [])
]
: [
...(Array.isArray(value?.UNCLASSIFIED?.altrnt_id_subtyp) ? value.UNCLASSIFIED["altrnt_id_subtyp"].map(item => `${item}//UnClassified`) : [])
],
StateProvince: stateProvince
}

}
return picklist;
}
}

const sortData = (Value) => {
const groupedEntries = {
Classified: [],
Unclassified: [],
};
Value.forEach((entry) => {
if (entry.includes("//UnClassified")) {
groupedEntries.Unclassified.push(entry);
} else {
groupedEntries.Classified.push(entry);
}
});

// Sort each group alphabetically
groupedEntries.Classified.sort();
groupedEntries.Unclassified.sort();

// Conditionally handle missing groups
const groupedOptions = [];

if (groupedEntries.Classified.length > 0) {
groupedOptions.push({ options: groupedEntries.Classified });
}
if (groupedEntries.Unclassified.length > 0) {
groupedOptions.push({ options: groupedEntries.Unclassified });
}
return groupedOptions
};

export default filter;